import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  FooterContainer,
  CompanyInfoContainer,
  CompanyInfoGrid,
  CompanyInfoItem,
  CompanyInfoLabel,
  CompanyInfoValue,
} from "./Footer.elements";

function Footer() {
  const [language, setLanguage] = useState('ko');
  const date = new Date();
  const location = useLocation();

  useEffect(() => {
    // URL 경로에서 언어 감지
    if (location.pathname.startsWith('/en')) {
      setLanguage('en');
    } else if (location.pathname.startsWith('/ko')) {
      setLanguage('ko');
    } else {
      const savedLang = localStorage.getItem('language') || 'ko';
      setLanguage(savedLang);
    }

    const handleLanguageChange = (e) => {
      setLanguage(e.detail);
    };

    window.addEventListener('languageChange', handleLanguageChange);
    return () => window.removeEventListener('languageChange', handleLanguageChange);
  }, [location.pathname]);

  const content = {
    ko: {
      company: '바삭한소프트',
      rights: `© ${date.getFullYear()} 바삭한소프트`,
      companyInfo: {
        companyName: '회사명',
        companyNameValue: '바삭한소프트',
        address: '주소',
        addressValue: '서울시 성동구 왕십리로 222, 한양대학교 코맥스스타트업타운 1층 유니콘룸',
        businessNumber: '사업자등록번호',
        businessNumberValue: '306-09-10281',
        ecommerce: '통신판매업신고번호',
        ecommerceValue: '제 2024-서울성동-0973 호',
        contact: '문의',
        contactValue: 'official@basakansoft.com'
      }
    },
    en: {
      company: 'Basakansoft',
      rights: `© ${date.getFullYear()} Basakansoft Inc.`,
      companyInfo: {
        companyName: 'Company',
        companyNameValue: 'Basakansoft',
        address: 'Address',
        addressValue: 'Unicorn Room, 1F KOMAX Startup Town, Hanyang University, 222 Wangsimni-ro, Seongdong-gu, Seoul',
        businessNumber: 'Business Registration',
        businessNumberValue: '306-09-10281',
        ecommerce: 'E-commerce Registration',
        ecommerceValue: '2024-Seoul Seongdong-0973',
        contact: 'Contact',
        contactValue: 'official@basakansoft.com'
      }
    }
  };

  return (
    <FooterContainer>      
      <CompanyInfoContainer>
        <CompanyInfoGrid>
          <CompanyInfoItem>
            <CompanyInfoLabel>{content[language].companyInfo.companyName}:</CompanyInfoLabel>
            <CompanyInfoValue>{content[language].companyInfo.companyNameValue}</CompanyInfoValue>
          </CompanyInfoItem>
          
          <CompanyInfoItem>
            <CompanyInfoLabel>{content[language].companyInfo.address}:</CompanyInfoLabel>
            <CompanyInfoValue>{content[language].companyInfo.addressValue}</CompanyInfoValue>
          </CompanyInfoItem>
          
          <CompanyInfoItem>
            <CompanyInfoLabel>{content[language].companyInfo.businessNumber}:</CompanyInfoLabel>
            <CompanyInfoValue>{content[language].companyInfo.businessNumberValue}</CompanyInfoValue>
          </CompanyInfoItem>
          
          <CompanyInfoItem>
            <CompanyInfoLabel>{content[language].companyInfo.ecommerce}:</CompanyInfoLabel>
            <CompanyInfoValue>{content[language].companyInfo.ecommerceValue}</CompanyInfoValue>
          </CompanyInfoItem>
          
          <CompanyInfoItem>
            <CompanyInfoLabel>{content[language].companyInfo.contact}:</CompanyInfoLabel>
            <CompanyInfoValue>{content[language].companyInfo.contactValue}</CompanyInfoValue>
          </CompanyInfoItem>
        </CompanyInfoGrid>
      </CompanyInfoContainer>
    </FooterContainer>
  );
}

export default Footer;
